import dayjs from 'dayjs';

function getMjesec(ts) {
  const datum = new Date(ts);
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(ts) {
  const datum = new Date(ts);
  return dayjs(datum).format('DD');
}

export default function Notification({ item }) {
  return (
    <div className="main-flex-notif-container">
      <div className="right-flex-container">
        <div className="upper-flex-container-tick">
          <div className="main-text-notif" style={{ margin: 5 }}>
            {item.headline}
          </div>
        </div>
        <div className="bottom-flex-container w-100" style={{ marginTop: 5 }}>
          <div className="w-100" dangerouslySetInnerHTML={{ __html: item.body }} />
        </div>
      </div>
      <div className="date-container" style={{ margin: 10 }}>
        <div>{getDan(item.ts)}</div>
        <div>{getMjesec(item.ts)}</div>
      </div>
    </div>
  );
}
